module.exports = __webpack_public_path__ + "img/icon-company-profile.1374f240.svg";